import { createFileRoute } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_app/billing-suspended')({
  component: BillingSuspendedPage,
})

const SUPPORT_EMAIL = 'support@cortado.pro'

/**
 * F8's suspended-state screen (R-83). An active suspend override (§3.5)
 * blocks access regardless of the org's underlying billing state, and it is
 * deliberately not something the account can pay its way back into - DEC-19
 * style, contact-support-only copy, no checkout offered. Full-screen and
 * routed like F7's hard gate: routes/_app.tsx's beforeLoad guard keeps
 * sending the user back here while billingState.isSuspended is true, and
 * away once it is lifted.
 */
export function BillingSuspendedPage() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-muted/30 p-6">
      <div className="w-full max-w-lg rounded-xl border bg-background p-8 text-center shadow-sm">
        <h1 className="text-2xl font-bold tracking-tight">Account suspended</h1>
        <p className="mt-3 text-muted-foreground">
          Your account has been suspended. Contact support to resolve this account&apos;s
          suspension — this isn&apos;t something a payment method can fix.
        </p>
        <Button asChild className="mt-6">
          <a href={`mailto:${SUPPORT_EMAIL}`}>Contact support</a>
        </Button>
      </div>
    </div>
  )
}
